import { TaxConfigurationEntity } from "../domain/taxConfiguration.entity";
import { TaxConfiguration, CityTaxConfiguration, RoomStayPercentageParams, PerPersonPerNightParams, BalearicParams } from "../../../../../gen/witbooking/backoffice/taxconfiguration/v1/taxconfiguration_api_pb";

const DEFAULT_VAT = 10;

export function toEntity({ ...props }: TaxConfiguration.AsObject): TaxConfigurationEntity {
  let amountPerNight: number | undefined;
  let minimumAge: number | undefined;
  let percentage: number | undefined;
  let cityTaxType: CityTaxConfiguration.CityTaxParametersCase =
    CityTaxConfiguration.CityTaxParametersCase.CITY_TAX_PARAMETERS_NOT_SET;
  const cityTaxConfiguration: CityTaxConfiguration.AsObject | undefined = props?.cityTaxList?.[0];
  if (cityTaxConfiguration?.balearicParams) {
    cityTaxType = CityTaxConfiguration.CityTaxParametersCase.BALEARIC_PARAMS;
    amountPerNight = cityTaxConfiguration.balearicParams.amountPerNight;
  }
  if (cityTaxConfiguration?.perPersonPerNight) {
    cityTaxType = CityTaxConfiguration.CityTaxParametersCase.PER_PERSON_PER_NIGHT;
    amountPerNight = cityTaxConfiguration.perPersonPerNight.amountPerNight;
    minimumAge = cityTaxConfiguration.perPersonPerNight.minimumage;
  }
  if (cityTaxConfiguration?.roomStayPercentageParams) {
    cityTaxType = CityTaxConfiguration.CityTaxParametersCase.ROOM_STAY_PERCENTAGE_PARAMS;
    percentage = cityTaxConfiguration.roomStayPercentageParams.percentage;
  }

  return {
    id: "taxConfiguration",
    amountPerNight,
    minimumAge,
    percentage,
    vatPercentage: props.vatPercentage || DEFAULT_VAT,
    roomType: cityTaxConfiguration?.roomType || undefined,
    cityTaxType,
  };
}

export function toDto(obj: TaxConfigurationEntity): TaxConfiguration {
  const result = new TaxConfiguration();
  result.setVatPercentage(obj.vatPercentage);
  const ctc = new CityTaxConfiguration();
  if (obj.roomType) {
    ctc.setRoomType(obj.roomType);
  }
  switch (obj.cityTaxType) {
    case CityTaxConfiguration.CityTaxParametersCase.ROOM_STAY_PERCENTAGE_PARAMS: {
      const params = new RoomStayPercentageParams();
      params.setPercentage(obj.percentage!);
      ctc.setRoomStayPercentageParams(params);
      break;
    }
    case CityTaxConfiguration.CityTaxParametersCase.PER_PERSON_PER_NIGHT: {
      const params = new PerPersonPerNightParams();
      params.setAmountPerNight(obj.amountPerNight!);
      params.setMinimumage(obj.minimumAge!);
      ctc.setPerPersonPerNight(params);
      break;
    }
    case CityTaxConfiguration.CityTaxParametersCase.BALEARIC_PARAMS: {
      const params = new BalearicParams();
      params.setAmountPerNight(obj.amountPerNight!);
      ctc.setBalearicParams(params);
      break;
    }
    default:
      throw new Error("Invalid city tax type");
  }
  result.setCityTaxList([ctc]);
  return result;
}
